module.exports = __webpack_public_path__ + "static/media/SHARP_red.06d10ee2.jpg";